export function normalizeZoom (percent) {
  const value = Number(percent)
  return Number.isFinite(value) ? Math.min(400, Math.max(30, value)) : 100
}

export function fitEditorZoom (viewportWidth, canvasWidth) {
  return normalizeZoom(Number(viewportWidth) / Number(canvasWidth) * 100)
}

// 标尺始终在视口像素空间绘制，只改变刻度的位置和间距，不缩放文字/线宽。
export function rulerTicks (length, origin, percent) {
  const zoom = normalizeZoom(percent) / 100
  const desired = 70 / zoom
  const power = Math.pow(10, Math.floor(Math.log10(desired)))
  const step = [1, 2, 5, 10].map(value => value * power).find(value => value >= desired)
  const minor = step / 5
  const start = Math.floor(-origin / zoom / minor)
  const end = Math.ceil((length - origin) / zoom / minor)
  const ticks = []
  for (let index = start; index <= end; index++) {
    const value = Math.round(index * minor * 1000) / 1000
    ticks.push({ value, position: origin + value * zoom, major: index % 5 === 0 })
  }
  return ticks
}

export function fitCanvasZoom (viewport, config, padding = 64) {
  return Math.floor(normalizeZoom(Math.min(
    Math.max(1, viewport.width - padding) / Number(config.width),
    Math.max(1, viewport.height - padding) / Number(config.height)
  ) * 100))
}

export function centeredCanvas (viewport, config, percent) {
  const zoom = normalizeZoom(percent) / 100
  return {
    panX: (viewport.width - Number(config.width) * zoom) / 2,
    panY: (viewport.height - Number(config.height) * zoom) / 2
  }
}

export function canvasViewport (config, editorZoom, editing, viewport = {}, runtimeFit = false) {
  let zoom = editing ? normalizeZoom(editorZoom) / 100 : 1
  let scaleX = zoom, scaleY = zoom
  if (!editing && runtimeFit) {
    const x = Math.max(0, Number(viewport.width) || 0) / Math.max(1, Number(config.width) || 1)
    const y = Math.max(0, Number(viewport.height) || 0) / Math.max(1, Number(config.height) || 1)
    if (config.fitType === '平铺') { scaleX = x; scaleY = y }
    else {
      zoom = config.fitType === '等宽' ? x : config.fitType === '等高' ? y : Math.min(x, y)
      scaleX = zoom; scaleY = zoom
    }
  }
  const width = Number(config.width) * scaleX
  const height = Number(config.height) * scaleY
  return {
    zoom, width, height,
    ...(!editing && runtimeFit ? { scaleX, scaleY } : {}),
    offsetX: editing ? 0 : Math.max(0, (Number(viewport.width) - width) / 2) || 0,
    offsetY: editing ? 0 : Math.max(0, (Number(viewport.height) - height) / 2) || 0
  }
}

export function screenToCanvas (point, viewport) {
  const zoom = normalizeZoom(viewport.zoom) / 100
  return {
    x: (point.x - (viewport.left || 0) - (viewport.panX || 0)) / zoom,
    y: (point.y - (viewport.top || 0) - (viewport.panY || 0)) / zoom
  }
}

export function canvasToScreen (point, viewport) {
  const zoom = normalizeZoom(viewport.zoom) / 100
  return {
    x: (viewport.left || 0) + (viewport.panX || 0) + point.x * zoom,
    y: (viewport.top || 0) + (viewport.panY || 0) + point.y * zoom
  }
}

// anchor 是鼠标相对缩放前画布原点的屏幕偏移，缩放后同一逻辑坐标仍留在鼠标下。
export function zoomViewportAt (viewport, percent, anchor) {
  const zoom = normalizeZoom(percent), ratio = zoom / normalizeZoom(viewport.zoom)
  return {
    zoom,
    panX: (Number(viewport.panX) || 0) + anchor.x * (1 - ratio),
    panY: (Number(viewport.panY) || 0) + anchor.y * (1 - ratio)
  }
}
